import gql from 'graphql-tag';

export const EDIT_WELCOME_MESSAGE_MUTATION = gql`
  fragment CommonWelcomeMessageFieldsEdit on WelcomeMessage {
    id
    title
    subtitle
    bodyText
    locale
  }
  mutation EditWelcomeMessage($id: ID!, $data: editWelcomeMessageInput!) {
    updateWelcomeMessage(input: { where: { id: $id }, data: $data }) {
      welcomeMessage {
        ...CommonWelcomeMessageFieldsEdit
      }
    }
  }
`;
